import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./components/components/home/Home";
import ProtectedRoute from "./ProtectedRoute";
import Login from "./components/components/authenticationComponents/Login";
import "./App.css";
import { AuthProvider, useAuth } from "./firebase/AuthProvider";
import LandingPage from "./components/components/landing/LandingPage";
import { NotificationProvider } from "./contexts/NotificationProvider";
import { ChatConnectionProvider } from "./contexts/ChatConnectionContext";
import GuestSignPage from "./components/components/fileViewer/pdfViewer/GuestSignPage";
import Footer from "./components/components/footer/Footer";
import OwnerDashboard from "./components/components/dashboard/OwnerDashboard/OwnerDashboard";
import ForgotPassword from "./components/components/authenticationComponents/ForgotPassword";
import { RegionProvider } from "./contexts/RegionContext";
import MfaSetupPage from "./components/components/authenticationComponents/MfaSetupPage";
import VerifyEmailPage from "./components/components/authenticationComponents/VerifyEmailPage";
import MfaVerifyPage from "./components/components/authenticationComponents/MfaVerifyPage";
import ChangePasswordPage from "./components/components/authenticationComponents/ChangePasswordPage";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/common.css";
import Addappointment from "./components/modal/Addappointment";
import Loader from "./components/components/loader/Loader";
import Privacypolicy from "./components/components/privacypolicy/Privacypolicy";
import CallSignalRListener from "./contexts/CallSignalConnectionContext";
import MeetingDetails from "./components/components/sproutHub/meetingDetails/MeetingDetails";
import CreateMeetingPage from "./components/components/sproutHub/CreateMeetingPage";
import BackendVideoRoom from "./components/components/sproutHub/BackendVideoRoom";
import Lobby from "./components/components/sproutHub/Lobby";
import ExternalUserOtpPage from "./components/components/ExternalUserOtpPage/ExternalUserOtpPage";
import ExternalUserRouteGuard from "./Routegaurd/ExternalUserRouteGuard";
import { AvatarProvider } from "./contexts/AvatarContext";
import 'react-calendar/dist/Calendar.css';
import VideoCallRoute from "./components/components/sproutHub/VideoCallRoute";
import { NotificationStateProvider } from "./contexts/NotificationStateContext";
import TermsOfService from "./components/legal/eSign/TermsOfService";
import DataProcessingAgreement from "./components/legal/eSign/DataProcessingAgreement";
import SecurityComplianceTerms from "./components/legal/eSign/SecurityComplianceTerms";
import ElectronicSignatureConsent from "./components/legal/eSign/ElectronicSignatureConsent";
import { ImagePreviewProvider } from "./contexts/ImagePreviewContext";
import { ImagePreviewModal } from "./components/ui/Modal/ImagePreviewModal";
import Feedback from "./components/feedback/Feedback";
import RoleBasedGuard from "./Routegaurd/RoleBasedGuard";
import ExternalFileUploadPage from "./components/components/ExternalFileupoadPage/ExternalFileUploadPage";
import { DynamicTitle } from "./components/DynamicTitle/DynamicTitle";

function App() {
    // Make sure your useAuth returns loading!
    const { currentUser, currentRoles, isLoading } = useAuth();
    // ... (rest of the component is unchanged)
    // Add loading check here
    if (isLoading) {
        return (
            <div
                style={{
                    minHeight: "100vh",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <Loader />
            </div>
        );
    }

    return (
        <>
            <Router>
                <DynamicTitle />
                <AuthProvider>
                    <RegionProvider>
                        <AvatarProvider>
                                <NotificationProvider>
                                    <NotificationStateProvider>
                                        <ChatConnectionProvider>
                                            <CallSignalRListener />
                                            <ImagePreviewProvider>
                                                <>
                                                    <Routes>
                                                        <Route path="/login" element={<Login />} />
                                                        <Route
                                                            path="/addappointment"
                                                            element={<Addappointment />}
                                                        />
                                                        <Route path="/landing-page" element={<LandingPage />} />
                                                        <Route path="/" element={<Login />} />
                                                        <Route
                                                            path="/forgot-password"
                                                            element={<ForgotPassword />}
                                                        />
                                                        <Route path="/verify-email" element={<VerifyEmailPage />} />
                                                        <Route path="/mfa-setup" element={<MfaSetupPage />} />
                                                        <Route path="/sign/:token" element={<GuestSignPage />} />
                                                        <Route path="/external/meeting-password/:ticketId" element={<ExternalUserOtpPage />} />
                                                        <Route element={<ExternalUserRouteGuard />}>
                                                            <Route path="/external/lobby/:roomId" element={<Lobby />} />
                                                            <Route path="/external/room/:roomId" element={<BackendVideoRoom />} />
                                                        </Route>
                                                    <Route
                                                        path="/forgot-password"
                                                        element={<ForgotPassword />}
                                                    />
                                                    <Route path="/verify-email" element={<VerifyEmailPage />} />
                                                    <Route path="/mfa-setup" element={<MfaSetupPage />} />
                                                    <Route path="/sign/:token" element={<GuestSignPage />} />
                                                    <Route path="/external/meeting-password/:ticketId" element={<ExternalUserOtpPage />} />
                                                    <Route element={<ExternalUserRouteGuard />}>
                                                        <Route path="/external/lobby/:roomId" element={<Lobby />} />
                                                        <Route path="/external/room/:roomId" element={<BackendVideoRoom />} />
                                                    </Route>

                                                    <Route path="/externalFileUpload" element={<ExternalFileUploadPage />} />

                                                    {/* Protected and Role-Based Routes */}
                                                    <Route element={<ProtectedRoute />}>
                                                        <Route element={<RoleBasedGuard />}>
                                                            <Route path="/feedback" element={<Feedback />} />
                                                            <Route path="/meeting" element={<CreateMeetingPage />} />
                                                            <Route element={<VideoCallRoute />}>
                                                                <Route path="/lobby/:roomId" element={<Lobby />} />
                                                                <Route path="/room/:roomId" element={<BackendVideoRoom />} />
                                                            </Route>
                                                            <Route path="/logout" element={<Login />} />
                                                            <Route
                                                                path="/change-password"
                                                                element={<ChangePasswordPage />}
                                                            />
                                                            <Route path="/*" element={<Home />} />
                                                        </Route>
                                                    </Route>

                                                    <Route path="legal/sign/tos" element={<TermsOfService />} />
                                                    <Route path="legal/sign/data-agreement" element={<DataProcessingAgreement />} />
                                                    <Route path="legal/sign/security-compliance-terms" element={<SecurityComplianceTerms />} />
                                                    <Route path="legal/sign/electronic-signature-consent" element={<ElectronicSignatureConsent />} />
                                                    <Route path="/privacypolicy" element={<Privacypolicy />} />
                                                    <Route path="/termsservices" element={<TermsOfService />} />
                                                </Routes>
                                            </>
                                            <ImagePreviewModal />
                                            <Footer />
                                        </ImagePreviewProvider>
                                    </ChatConnectionProvider>
                                </NotificationStateProvider>
                            </NotificationProvider>
                        </AvatarProvider>
                    </RegionProvider>
                </AuthProvider>
            </Router>
        </>
    );
}

export default App;
